import script from "./terracycle-intro.vue?vue&type=script&lang=ts&setup=true"
export * from "./terracycle-intro.vue?vue&type=script&lang=ts&setup=true"

import "./terracycle-intro.vue?vue&type=style&index=0&id=03ceb77e&lang=scss"

const __exports__ = script;

export default __exports__